import { IconButton, Tooltip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { useLocalization } from 'hooks/useLocalization';

interface CloseButtonProps {
	handleClose: () => void;
}

function CloseButton({ handleClose }: CloseButtonProps) {
	const { getStr } = useLocalization();

	return (
		<Tooltip title={getStr('Close')}>
			<IconButton
				aria-label={getStr('Close')}
				onClick={handleClose}
				sx={{
					width: 48, // Ensure a fixed width
					height: 48, // Ensure a fixed height to maintain aspect ratio
					borderRadius: '50%', // Maintain circular shape
					color: 'rgba(0, 0, 0, 0.87)',
					// Custom hover style can also be defined here if needed
				}}
			>
				<CloseIcon />
			</IconButton>
		</Tooltip>
    );
}

export default CloseButton;